angular.module('app').factory('liveCasinoService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer) {
            Configurer.setBaseUrl(settings.apiURL);
        });

        var pages = restAngular.all("/page/");

        return {
            save: function (requestData) {
                return pages.
                one("saveLiveCasino").
                post("", requestData)
            },
            load: function (requestOptions) {
                return pages.
                one("getLiveCasino").
                customGET(param(requestOptions))
            }
        }
    }
    ]);
